import React, { useEffect, useContext, useState } from "react";
import { AiFillCloseCircle } from "react-icons/ai";
import {
  Drawer,
  FormControlLabel,
  Radio,
  RadioGroup,
  Snackbar,
  TextField,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";

import "./index.css";
import { api_call, api_call_token, formDataApi } from "../../utils/Network";
import { MainContext } from "../../utils/context";
import OTPInput from "../OtpInput";
import LOGIN from "../../assets/login.png";
import { isMobiledevice, saveLocalData } from "../../utils/helperFunctions";

export default function LoginPopup({
  show = false,
  updateUser = { gender: 1, dob: "2001-01-01" },
  onClose = () => null,
  onSuccess = () => null,
}) {
  const { setUserData, cartData, setCartData } = useContext(MainContext);
  const [numberVerified, setNumberVerified] = useState(false);
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [isNewUser, setIsNewUser] = useState(false);
  const [user, setUser] = useState({});
  const [msg, setMsg] = useState("");

  useEffect(() => (setIsNewUser(false), setNumberVerified(false)), [show]);
  useEffect(() => {
    setUser({
      ...updateUser,
      first_name: updateUser.complete_name,
      gender:
        updateUser.gender === "FEMALE"
          ? 2
          : updateUser.gender === "MALE"
          ? 1
          : 0,
    });
  }, [updateUser]);

  if (!show) return <></>;

  const numberVerifyHandler = () => {
    if (parseInt(mobile).toString().length === 10) {
      api_call
        .post("auth/user/send_otp/", {
          isd: "+91",
          phone: mobile,
        })
        .then((res) => {
          setNumberVerified(true);
          if (res.data.data?.has_account) setIsNewUser(false);
          else setIsNewUser(true);
        })
        .catch((e) => console.log(e));
    } else setMsg("Please enter valid mobile number");
  };

  const otpVerifyHandler = () => {
    if (otp.length === 6) {
      const data = {
        isd: "+91",
        phone: mobile,
        code: otp,
      };
      api_call
        .post("auth/user/verify_otp/", data)
        .then((res) => {
          if (res.status === 200 && res.data.data?.user) {
            api_call
              .post(`auth/user/${res.data.data.user}/me/`, data)
              .then((re) => {
                if (re.data.data?.token?.access) {
                  saveLocalData("refreshToken", re.data.data.token.refresh);
                  saveLocalData("accessToken", re.data.data.token.access);
                }
                if (re.data.data?.user) setUserData(re.data.data.user);
                if (re.data.data?.user?.first_name) {
                  updateCartHandler(res.data.data.user);
                  onSuccess("Login Successful");
                } else {
                  setUser({ ...re.data.data.user, id: res.data.data.user });
                }
                setNumberVerified(false);
                setMobile("");
                setOtp("");
              })
              .catch((err) => console.log(err.response));
          } else setMsg("Please enter valid OTP");
        })
        .catch((e) => console.log(e));
    } else setMsg("Please enter valid OTP");
  };

  const updateProfileHandler = async () => {
    if (user.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(user.email))
      return setMsg("Please enter valid email !");
    let name = { first_name: user.first_name };
    if (user.first_name.includes(" ")) {
      const i = user.first_name.indexOf(" ");
      name = {
        first_name: user.first_name.slice(0, i),
        last_name: user.first_name.slice(i + 1),
      };
    }
    const fmData = new FormData();
    fmData.append("first_name", name.first_name);
    fmData.append("last_name", name.last_name || "");
    fmData.append("gender", user.gender);
    fmData.append("email", user.email || "");
    fmData.append("dob", user.dob || "");
    const userObj = await formDataApi(fmData);
    if (userObj.id) {
      setUserData(userObj);
      if (isNewUser) {
        setIsNewUser(false);
        updateCartHandler(userObj.id);
        onSuccess("Registration Successful");
      }
      onSuccess("Profile Updation Successful");
    } else onClose();
  };

  const updateCartHandler = async (userId = 0) => {
    if (cartData && cartData.length) {
      let data = [];
      cartData.forEach((crtItm) => {
        data.push({ ...crtItm, user_id: userId });
        if (crtItm.sub_service?.length)
          crtItm.sub_service.forEach((ss) =>
            data.push({
              ...ss,
              user_id: userId,
              variant_type: crtItm.variant_type,
              sub_variant_type: crtItm.sub_variant_type,
            })
          );
      });
      await api_call_token
        .post("auth/cart/create_cart/", data)
        .then((re) => console.log(re))
        .catch((e) => console.log(e));
    }
    await api_call_token
      .get("auth/cart/view_cart/")
      .then((r) => setCartData(r.data.data))
      .catch((e) => console.log(e));
  };

  const content = (
    <div className="login-container">
      {!user.id ? (
        <>
          <div className="login-header">{isNewUser ? "Register" : "Login"}</div>
          <div className="login-mobile">
            <span className="login-isd">+91</span>
            <input
              onChange={(e) => setMobile(e.target.value)}
              placeholder="Enter Phone number"
              className="login-input"
              maxLength={10}
              type="tel"
              inputMode="tel"
              disabled={numberVerified}
            />
          </div>
          {numberVerified && (
            <>
              <label className="login-label">Enter OTP :</label>
              <OTPInput
                autoFocus
                // isNumberInput
                length={6}
                className="otpContainer"
                inputClassName="otpInput"
                onChangeOTP={setOtp}
              />
            </>
          )}
          {numberVerified && (
            <div onClick={numberVerifyHandler} className="resend-otp">
              Resend OTP
            </div>
          )}
          <button
            onClick={() => {
              numberVerified ? otpVerifyHandler() : numberVerifyHandler();
            }}
            className="login-btn"
          >
            {isNewUser ? "Continue" : numberVerified ? "Login" : "Send OTP"}
          </button>
        </>
      ) : (
        <>
          {/* <div style={{ paddingBottom: 100 }}> */}
          {/* <input
              accept="image/*"
              // className={classes.input}
              id="upload-btn"
              onChange={({ target }) => {
                const fileReader = new FileReader();
                fileReader.readAsDataURL(target.files[0]);
                fileReader.onload = (e) => {
                  console.log(e.target.result, target.files[0]);
                };
              }}
              type="file"
              hidden
              multiple={false}
            />
            <label htmlFor="upload-btn">
              <IconButton color="primary" component="span">
                <AiOutlineUpload />
              </IconButton>
            </label> */}
          <TextField
            id="standard-full-width"
            required
            label="Full Name"
            style={{ margin: 8 }}
            placeholder="Ex. Grf Abc"
            fullWidth
            margin="normal"
            InputLabelProps={{
              shrink: true,
            }}
            error={!user.first_name}
            value={user.first_name}
            onInput={(e) => setUser({ ...user, first_name: e.target.value })}
          />
          <TextField
            id="standard-full-width"
            label="Email"
            style={{ margin: 8 }}
            placeholder="Ex. abc@grf.com"
            fullWidth
            margin="normal"
            InputLabelProps={{ shrink: true }}
            value={user.email}
            error={user.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(user.email)}
            onInput={(e) => setUser({ ...user, email: e.target.value })}
          />
          <span
            style={{
              textAlign: "left",
              width: "100%",
              // marginTop: 10,
              fontSize: 13,
              color: "rgba(0, 0, 0, 0.54)",
            }}
          >
            Gender
          </span>
          <RadioGroup row aria-label="gender" name="gender">
            <FormControlLabel
              control={
                <Radio
                  checked={user.gender === 1}
                  onClick={() =>
                    setUser({ ...user, gender: user.gender === 1 ? 0 : 1 })
                  }
                  size="small"
                  color="primary"
                />
              }
              label="Male"
            />
            <FormControlLabel
              // value={2}
              control={
                <Radio
                  checked={user.gender === 2}
                  onChange={() =>
                    setUser({ ...user, gender: user.gender === 2 ? 0 : 2 })
                  }
                  size="small"
                  color="primary"
                />
              }
              label="Female"
            />
          </RadioGroup>
          <TextField
            id="date"
            label="Date of birth"
            type="date"
            fullWidth
            defaultValue={user.dob}
            InputLabelProps={{ shrink: true }}
            onChange={(e) => setUser({ ...user, dob: e.target.value })}
          />
          <button
            style={
              user.first_name
                ? {}
                : { backgroundColor: "#ddd", cursor: "not-allowed" }
            }
            disabled={!user.first_name}
            onClick={updateProfileHandler}
            className="login-btn"
          >
            {isNewUser ? "Register" : "Update Profile"}
          </button>
        </>
      )}
    </div>
  );

  return (
    <>
      {isMobiledevice() ? (
        <Drawer
          PaperProps={{
            style: { borderTopRightRadius: 25, borderTopLeftRadius: 25 },
          }}
          open={show}
          onClose={() =>
            isNewUser && !user.first_name
              ? setMsg("Please Complete Registration !")
              : onClose()
          }
          anchor="bottom"
        >
          {content}
        </Drawer>
      ) : (
        <Modal
          modalStyle={
            window.innerWidth < 940 ? {} : { backgroundImage: `url(${LOGIN})` }
          }
          show={show}
          onClose={() =>
            isNewUser && !user.first_name
              ? setMsg("Please Complete Registration !")
              : onClose()
          }
        >
          {content}
        </Modal>
      )}
      {msg && (
        <Snackbar
          open
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          onClose={() => setMsg("")}
          autoHideDuration={3000}
          message={msg}
        >
          <Alert severity="error">{msg}</Alert>
        </Snackbar>
      )}
    </>
  );
}

const Modal = ({ modalStyle, children, show, onClose, backdropStyle }) => {
  return (
    <React.Fragment>
      <div style={backdropStyle} className={show ? "modal visible" : "modal"}>
        <div
          style={{
            width: 60,
            height: 40,
            position: "absolute",
            top: 0,
            right: 0,
            margin: "1rem",
            cursor: "pointer",
          }}
        >
          <AiFillCloseCircle onClick={onClose} className="close-icon" />
        </div>
        <div style={modalStyle} className="login_modal_wrap">
          {children}
        </div>
      </div>
    </React.Fragment>
  );
};
